export enum InvoiceEmailAttachmentType {
  Billet='Billet', Document='Document', Receipt='Receipt', Nfe='Nfe', Nfc='Nfc'
}
